import React, {Component} from 'react'
import {$$} from '../../../helpers/localization'
import {CONVERTER} from '../../../utils/converter'
import PropTypes from "prop-types";

export default class HydrationForm extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                {this.props.hydration ? $$('hydration_label') : null}<br/>
                <div className="form-group">
                    <div className="input-group mb-3">
                        <input type="number" step="0.01"
                               className={this.props.errors.hydration ? "custom-error form-control" : "form-control"}
                               value={this.props.hydration} placeholder={$$('hydration_label')}
                               name="hydration" onChange={this.props.onInputChange} required/>
                        <div className="input-group-append">
                            <span className="input-group-text" style={{"height": "auto"}}
                                  id="basic-addon2">{CONVERTER.getUnitByType('HYDRATION')}</span>
                        </div>
                    </div>
                    <div
                        className={this.props.errors.hydration ? "custom-invalid-feedback" : "invalid-feedback"}>
                        {this.props.errors.hydration ? $$(this.props.errors.hydration) : $$('hydration_required_message')}
                    </div>
                </div>
            </div>
        )
    }
}

HydrationForm.propTypes = {
    clearSelectedEntry: PropTypes.func,
    createEntry: PropTypes.func,
    fetchSelectedUserHealthIssues: PropTypes.func,
    formDisabled: PropTypes.object,
    getHealthIssueList: PropTypes.func,
    healthIssues: PropTypes.object,
    errors: PropTypes.any,
    hydration: PropTypes.any,
    logbookEntries: PropTypes.array,
    medicalProfile: PropTypes.object,
    onHide: PropTypes.func,
    selectedUser: PropTypes.object,
    settings: PropTypes.object,
    show: PropTypes.bool,
    type: PropTypes.string,
    updateEntry: PropTypes.func,
    onInputChange: PropTypes.func,
    updateUserMedicalProfile: PropTypes.func
}